import React from 'react';

import { enforceElement, RenderableElement } from '@/utils/elements';

import {
  Panel,
  PanelHeading,
  PanelTitle,
  PanelFeedback,
  PanelActions,
} from './styles';

interface Props {
  title: string;
  feedback?: string;
  state?: 'marked' | 'half-marked' | 'unmarked';
  onClick?: React.MouseEventHandler<HTMLElement>;
  Actions?: RenderableElement;
  style?: React.CSSProperties;
  className?: string;
  readOnly?: boolean;
}

const SectionPanel: React.FC<Props> = ({
  title,
  feedback,
  state,
  onClick,
  Actions,
  style,
  className,
  readOnly = false,
}) => {
  return (
    <Panel style={style} className={className}>
      <PanelHeading>
        <PanelTitle
          onClick={onClick}
          state={state}
          readOnly={readOnly || !!feedback}
        >
          {title}
        </PanelTitle>

        {Actions && <PanelActions>{enforceElement(Actions)}</PanelActions>}
      </PanelHeading>

      {feedback && (
        <PanelFeedback onClick={onClick} state={state} readOnly={readOnly}>
          {feedback}
        </PanelFeedback>
      )}
    </Panel>
  );
};

export default SectionPanel;
